module.exports = __webpack_public_path__ + "img/PXL_20230526_112214863.fee8a04b.jpg";